import {
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, useDisclosure,
    Stack, Radio, RadioGroup,
    Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon,
    Box, Button
} from "@chakra-ui/react"
import { createCheckoutSession } from "../../features/subscription/subscriptionSlice"
import { useDispatch } from "react-redux"
import { useState } from "react"
import PlanSelectionView from "../../pages/page_elements/PlanSelectionView";


export default function PlanSelectionModal({ isOpen, onClose }) {

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Choose your plan</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <PlanSelectionView />
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}